import React, { useEffect, createElement } from 'react';
export function HubSpotForm() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js-ap1.hsforms.net/forms/embed/442659207.js';
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="hs-form-frame" data-region="ap1" data-form-id="43a39b50-277d-4bbf-960f-79b1bee406d8" data-portal-id="442659207" data-id="element-364"></div>;
}